<template>

  <div v-if="facilities && chip_facilities">

    <v-card class="ma-1" outlined>

      <v-card-title style="height: 64px">
        Facilități
        <v-spacer/>
        <v-btn x-small fab depressed color="primary" @click="dialog=!dialog">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider class="mx-4"/>

      <v-card-text style="height: 420px; overflow-y: auto">
        <template v-if="!hotel.static.facilities.length">
          <v-alert dark color="error">
            <v-row no-gutters align="center">
              <v-icon left>mdi-alert</v-icon>
              Facilitățiile hotelului nu sunt complete.
            </v-row>
          </v-alert>
        </template>
        <template v-else>
          <div class="ma-n1">
            <v-chip v-for="(facility, index) in hotel.static.facilities" :key="index" class="ma-1" label>
              {{chip_facilities[facility].name}}
            </v-chip>
          </div>
        </template>
      </v-card-text>

    </v-card>

    <v-dialog v-model="dialog" width="960">
      <v-card>

        <v-toolbar color="primary" flat dark>
          <v-toolbar-title>Facilități</v-toolbar-title>
          <v-spacer/>
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <div class="pa-3">
          <v-autocomplete v-model="hotel.static.facilities" :items="facilities" item-value="id" class="ma-1" item-text="name" label="Facilități" multiple outlined dense hide-details>
            <template v-slot:selection="data">
              <v-chip v-bind="data.attrs" :input-value="data.selected" @click:close="onFacilityRemoved(data.item)" close small>
                {{data.item.name}}
              </v-chip>
            </template>
          </v-autocomplete>
        </div>

        <v-divider class="mx-2"/>

        <v-card-actions>
          <v-btn color="primary" text @click="cancel">
            Anuleaza
          </v-btn>
          <v-spacer/>
          <v-btn color="primary" depressed @click="save">
            Salveaza
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </div>


</template>

<script>

  import config_repository from '@/repositories/config-repository'

  export default {

    props: {
      hotel: null
    },

    data: () => ({
      dialog: false,
      facilities: null,
      chip_facilities: null
    }),

    async created() {
      this.facilities = await config_repository.getHotelFacilities();
      this.chip_facilities = _.keyBy(this.facilities, 'id')
    },

    methods: {

      save() {
        this.dialog = false;
        this.$emit('save');
      },

      cancel() {
        this.dialog = false;
        this.$emit('cancel');
      },

      onFacilityRemoved(facility) {
        const index = this.hotel.static.facilities.indexOf(facility.id);
        if (index >= 0) this.hotel.static.facilities.splice(index, 1)
      }

    }

  }
</script>